import React, { useEffect, useState } from 'react'

// Services Firebase
import { collection, doc, getDoc, getDocs, orderBy, query } from 'firebase/firestore'
import { db } from '../../firebase'

// import { doc} from 'firebase/firestore'


// CSS
import "../../css/listBlogs.css"
import { useNavigate } from 'react-router-dom'
import { Link } from 'react-router-dom'
function ListBlogs() {
    const navigate = useNavigate()
const [listBlogs, setListBlogs] = useState()
const [isFetching, setIsFetching] = useState(true);


useEffect(() => {
 getData()
}, [])
const getData = async () => {
  const blogs = [];
  try {
    // 👇 Query ordenada por fecha de creación (más nuevos primero)
    const blogRef = collection(db, "blogs");
    const q = query(blogRef, orderBy("createdAt", "desc"));
    const getBlogs = await getDocs(q);

    getBlogs.forEach((doc) => {
      blogs.push({ ...doc.data() });
    });

    setListBlogs(blogs);
    setIsFetching(false);
  } catch (error) {
    navigate("error");
  }
};
console.log("listBlogs", listBlogs);

if(isFetching === true) {
    return <div class="d-flex justify-content-center">
    <div class="spinner-border" role="status">
      <span class="sr-only"></span>
    </div>
  </div>
  }

  return (
    <div className='list-blogs-container'>
        {
            listBlogs.map((eachBlog) => {
                return(
        <div className='blog-container' id={eachBlog.id}>
            <div className='image-blog'>
                <img src={eachBlog.picture} alt="pic" />
            </div>
            <div className='dj-description' style={{ whiteSpace: 'pre-line', overflow: 'hidden' }}>
                <p>{eachBlog.description}</p>
            </div>
            { eachBlog.link !== "" &&
            <div className='link-blog'>
                <Link to={eachBlog.link} target="_blank">Haz clik aquí para ver el vídeo</Link>
            </div>
            }
        </div>
                )
            })
        }
            
    </div>
  )
}

export default ListBlogs